import React, { useContext, useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { ProductContext } from "../contexts/ProductContext";
import Search from "../components/productsPage/Search";
import SortFilter from "../components/productsPage/SortFilter";

import ProductList from "../components/productsPage/ProductList";
import ProductLayout from "../components/productsPage/ProductLayout";
import { useLocation } from "react-router-dom";

function Products() { //(props)
  const { products } = useContext(ProductContext);

  const [filterProducts, setFilterProducts] = useState(products);
  const [gridLayoutClass, setGridLayoutClass] = useState('grid-cols-2');

  useEffect(() => {
    setFilterProducts(products);
    // console.log(products);
  }, [products]);
  

  const receiveFilterProducts = (value) => {
    setFilterProducts(value);
  };
  
  const receiveGridLayoutClass = (value) => {
    setGridLayoutClass(value);
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const searchValue = queryParams.get('search');

  useEffect(() => {
    if(searchValue){
      const lowerCaseQuery = searchValue?.toLowerCase().trim();
      const filteredProducts = products.filter((product) =>
        // JSON.stringify(product)?.toLowerCase().includes(lowerCaseQuery)
        JSON.stringify(product)?.toLowerCase().includes(lowerCaseQuery)
        
      );
      setFilterProducts(filteredProducts);
    }
      
  }, [products,searchValue])
  

  return (
    <div id="products">
      <Navbar/>
      <Search key={searchValue} products={products} setProducts={receiveFilterProducts} searchInput={searchValue}/>
      <SortFilter products={products} setProducts={receiveFilterProducts}/>
      <ProductLayout filterProductsLength={filterProducts.length}  setGridLayoutCss={receiveGridLayoutClass}/>
      <ProductList products={filterProducts} gridClass={gridLayoutClass}/>
      <Footer/>
    </div>
  );
}

export default Products;

// old product bad code page/*
/*
import React, { useContext, useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ProductCard from "../components/ProductCard";
import { FiSearch } from "react-icons/fi";
import { ProductContext } from "../contexts/ProductContext";
import { FiChevronDown } from "react-icons/fi";
import { FiChevronUp } from "react-icons/fi";

function Products() {
  const { products } = useContext(ProductContext);

    const [gridLayout, setGridLayout] = useState('two-product');


    let gridClass;
    switch (gridLayout) {
      case 'one-product':
        gridClass = 'grid-cols-1';
        break;
      case 'two-product':
        gridClass = 'grid-cols-2';
        break;
      case 'four-product':
        gridClass = 'grid-cols-4';
        break;
      default:
        gridClass = 'grid-cols-2'; // Default to two-column layout
    }
  
    const [visibleProducts, setVisibleProducts] = useState(10);

    const handleShowMore = () => {
        setVisibleProducts(prevVisibleProducts => prevVisibleProducts + 10); // Show 10 more products
      };
/*
    const allProducts = [
        {
          "name": "City Breeze White Cargo Pant",
          "price": 1599,
          "image": [
            "assets/All-products/allproducts09.jpg",
            "assets/All-products/allproducts10.jpg",
            
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "Wild Enough Brown Overshirt",
          "price": 1699,
          "image": [
             "assets/All-products/allproducts15.jpg",
            "assets/All-products/allproducts16.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "Wild Enough Olive Overshirt",
          "price": 1699,
          "image": [
             "assets/All-products/allproducts18.jpg",
            "assets/All-products/allproducts19.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "Wild Enough Green Overshirt",
          "price": 1699,
          "image": [
             "assets/All-products/allproducts21.jpg",
            "assets/All-products/allproducts22.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "Patchwork Checks Blue Shirt",
          "price": 1199,
          "image": [
             "assets/All-products/allproducts24.jpg",
            "assets/All-products/allproducts25.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "City Breeze Navy Cargo Pant",
          "price": 1599,
          "image": [
             "assets/All-products/allproducts27.jpg",
            "assets/All-products/allproducts28.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "City Breeze Grey Cargo Pant",
          "price": 1599,
          "image": [
             "assets/All-products/allproducts30.jpg",
            "assets/All-products/allproducts31.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "City Breeze Cream Cargo Pant",
          "price": 1599,
          "image": [
             "assets/All-products/allproducts33.jpg",
            "assets/All-products/allproducts34.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "City Breeze Black Cargo Pant",
          "price": 1599,
          "image": [
             "assets/All-products/allproducts36.jpg",
            "assets/All-products/allproducts37.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "Waffle Weave Cream T-Shirt",
          "price": 999,
          "image": [
             "assets/All-products/allproducts39.jpg",
            "assets/All-products/allproducts40.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "Waffle Weave Blue T-Shirt",
          "price": 999,
          "image": [
             "assets/All-products/allproducts42.jpg",
            "assets/All-products/allproducts43.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "Waffle Weave Grey T-Shirt",
          "price": 999,
          "image": [
             "assets/All-products/allproducts45.jpg",
            "assets/All-products/allproducts46.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "Blockade Checks White Shirt",
          "price": 1099,
          "image": [
             "assets/All-products/allproducts48.jpg",
            "assets/All-products/allproducts49.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "Blockade Checks Grey Shirt",
          "price": 1099,
          "image": [
             "assets/All-products/allproducts51.jpg",
            "assets/All-products/allproducts52.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "Blockade Checks Pink Shirt",
          "price": 1099,
          "image": [
             "assets/All-products/allproducts54.jpg",
            "assets/All-products/allproducts55.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "Pull On Sky Blue Baggy Fit Jeans",
          "price": 1699,
          "image": [
             "assets/All-products/allproducts57.jpg",
            "assets/All-products/allproducts58.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "Plush Pulse Green Overshirt",
          "price": 1499,
          "image": [
             "assets/All-products/allproducts60.jpg",
            "assets/All-products/allproducts61.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "Plush Pulse Navy Overshirt",
          "price": 1499,
          "image": [
             "assets/All-products/allproducts63.jpg",
            "assets/All-products/allproducts64.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "Plush Pulse Black Overshirt",
          "price": 1499,
          "image": [
             "assets/All-products/allproducts66.jpg",
            "assets/All-products/allproducts67.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        },
        {
          "name": "City Slicker Ink Blue Boot Cut Jeans",
          "price": 1799,
          "image": [
             "assets/All-products/allproducts69.jpg",
            "assets/All-products/allproducts70.jpg",
          ],"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed commodo nisi et libero blandit lacinia.",
          "details": {
            "fabric": "100% Polyester",
            "fit": "Regular Fit",
            "size": "S, M, L, XL",
            "modelHeight": "5 Feet 10 Inches"
          },
          "category": "Shirts",
          "color": "Brown",
          "newArrival": false,
          "bestSeller": false,
          "trending": true,
          "stars": 4.5,
          "reviews": 20,
          "tags": ["casual", "comfortable", "stylish"]
        }
      ]*/
      
//       const [selectedSort, setSelectedSort] = useState('Sort');
//       const [filterProducts, setFilterProducts] = useState(products);

//     //   const relatedProducts = allProducts.filter(product => 
//     //     product.category === selectedProduct.category && product.name !== selectedProduct.name
//     //   );
//     useEffect(() => {
//       setFilterProducts(products)
//       console.log(products)
//     }, [products])
    
//     const [isVisibleFilter, setIsVisibleFilter] = useState(false);

    
//       const handleSortChange = (event) => {
//         setIsVisibleFilter(false);
//         // setSelectedSort(event)
//         const sortType = event;
//         let sortedProducts = [];
      
//         switch (sortType) {
//           case "lowToHigh":
//             setSelectedSort('Price (Low to High )')
//             sortedProducts = products.sort((a, b) => a.price - b.price);
//             break;
//           case "highToLow":
//             setSelectedSort('Price (High to Low)')
//             sortedProducts = products.sort((a, b) => b.price - a.price);
//             break;
//           case "newArrival":
//             setSelectedSort('Newly Added')
//             sortedProducts = products.filter(product => product.newArrival);
//             break;
//           case "trendings":
//             setSelectedSort('Revelance')
//             sortedProducts = products.filter(product => product.trending);
//             break;
//           case "bestSeller":
//             setSelectedSort('Best Seller')
//             sortedProducts = products.filter(product => product.bestSeller);
//             break;
//           case "stars":
//             setSelectedSort(event)
//             sortedProducts = products.sort((a, b) => b.stars - a.stars);
//             break;
//           case "latest":
//             setSelectedSort(event)
//             sortedProducts = products.filter(product => product.newArrival);
//             break;
//             case "all":
//               setSelectedSort('All')
//             sortedProducts = products
//             break;
//           default:
//             sortedProducts = products;
//         }
//         setFilterProducts(sortedProducts);

//         // Update the state or do something with sortedProducts
//       };

//       //search Logic
//       const [searchQuery, setSearchQuery] = useState('');
  
//       // Event handler to update the search query
//       const handleSearchInputChange = (event) => {
//         if(event.target.value === ''){
//             setFilterProducts(products);
//         }
//           setSearchQuery(event.target.value);
//       };
  
//       // Function to filter products based on search query
//       const filterProductList = () => {
//         const lowerCaseQuery = searchQuery.toLowerCase().trim();
//         // const filtered = products.filter(product =>
//         //     product.name.toLowerCase().includes(lowerCaseQuery)
//         // );
//         const filtered = products.filter(product =>
//           JSON.stringify(product).toLowerCase().includes(lowerCaseQuery)
//       );
//         setFilterProducts(filtered);
//     };
  
//       // Event handler to handle Enter key press
//       const handleKeyPress = (event) => {
//           if (event.key === 'Enter') {
//             filterProductList();
//           }
//       };

//   return (
//     <div id="products">
//       <Navbar />
//       <div className="container">
//         <div className="py-6 p-2 pt-8 w-full search-container">
//           <div className="flex justify-between item-center px-4 p-2 border search-box">
//             <input
//               className="shadow-none m-0 p-0 border-none w-[80%] outline-none"
//               type="text"
//               placeholder="Search for products in this collection"
//               value={searchQuery}
//                     onChange={handleSearchInputChange}
//                     onKeyDown={handleKeyPress}
//             />
//             <FiSearch className="text-primary text-xl hover:text-black cursor-pointer" onClick={filterProductList}/>
//           </div>
//         </div>
//         <div className="filter-container">
//           <div className="flex justify-center items-center px-2 filter-box">
//             <div className="w-1/2 revelance-container">
//               <div class="relative font-primaryFont cursor-pointer group">
//                 <div onClick={() => setIsVisibleFilter(!isVisibleFilter)} class="flex justify-between items-center border-y-[1px] bg-white px-4 py-2 border-r-[1px]">
//                   <a 
//                     class="lg:mx-4 py-2 font-medium text-base text-primary menu-hover"

//                   >
//                 {selectedSort || 'Sort'}
//                   </a>
//                   <span>
//                     {/* <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       strokeWidth="1.5"
//                       stroke="currentColor"
//                       class="w-6 h-6"
//                     >
//                       <path
//                         stroke-linecap="round"
//                         stroke-linejoin="round"
//                         d="M19.5 8.25l-7.5 7.5-7.5-7.5"
//                       />
//                     </svg> */}
//                    { isVisibleFilter ? <FiChevronDown className="text-xl"/>
//                    : <FiChevronUp className="text-xl"/>}
//                   </span>
//                 </div>

//                 <div className={`z-50 absolute  flex-col bg-gray-100 shadow-xl px-4 py-1 w-full font-primaryFont text-gray-800 ${isVisibleFilter ? 'flex' : 'hidden'}`}>
//                 <a   onClick={() => handleSortChange('all')} class="block border-gray-100 md:mx-2 my-2 py-1 border-b font-semibold text-gray-500 hover:text-black">
//                   All
//                   </a>
//                 <a   onClick={() => handleSortChange('newArrival')} class="block border-gray-100 md:mx-2 my-2 py-1 border-b font-semibold text-gray-500 hover:text-black">
//                   Newly Added
//                   </a>
//                   <a  onClick={() => handleSortChange('bestSeller')}  class="block border-gray-100 md:mx-2 my-2 py-1 border-b font-semibold text-gray-500 hover:text-black">
//                     Best Seller
//                   </a>

//                   <a  onClick={() => handleSortChange('trendings')}  class="block border-gray-100 md:mx-2 my-2 py-1 border-b font-semibold text-gray-500 hover:text-black">
//                     Revelance
//                   </a>

//                   <a  onClick={() => handleSortChange('highToLow')}  class="block border-gray-100 md:mx-2 my-2 py-1 border-b font-semibold text-gray-500 hover:text-black">
//                   Price (High to Low)
//                   </a>

//                   <a  onClick={() => handleSortChange('lowToHigh')}  class="block border-gray-100 md:mx-2 my-2 py-1 border-b font-semibold text-gray-500 hover:text-black">
//                   Price (Low to High )
//                   </a>

                

                 
//                 </div>
//               </div>
//             </div>
//             <div className="w-1/2 refine-by-container">
//               <div class="relative cursor-pointer group">
//                 <div class="flex justify-between items-center border-y-[1px] bg-white px-4 py-2 font-primaryFont">
//                   <a
//                     class="lg:mx-4 py-2 font-medium hover:font-semibold text-base text-primary menu-hover"
                   
//                   >
//                    Refine By
//                   </a>
//                   <span>
//                   <svg
//   xmlns="http://www.w3.org/2000/svg"
//   fill="none"
//   viewBox="0 0 16 16"
//   className="w-6 h-6"
// >
//   <path
//     strokeLinecap="round"
//     strokeLinejoin="round"
//     d="M0.8 3.2H3.348C3.6792 4.1288 4.5584 4.8 5.6 4.8C6.6416 4.8 7.5208 4.1288 7.852 3.2H15.2C15.6424 3.2 16 2.8424 16 2.4C16 1.9576 15.6424 1.6 15.2 1.6H7.852C7.5208 0.6712 6.6416 0 5.6 0C4.5584 0 3.6792 0.6712 3.348 1.6H0.8C0.3576 1.6 0 1.9576 0 2.4C0 2.8424 0.3576 3.2 0.8 3.2ZM15.2 12.8H7.852C7.5208 11.8712 6.6416 11.2 5.6 11.2C4.5584 11.2 3.6792 11.8712 3.348 12.8H0.8C0.3576 12.8 0 13.1576 0 13.6C0 14.0424 0.3576 14.4 0.8 14.4H3.348C3.6792 15.3288 4.5584 16 5.6 16C6.6416 16 7.5208 15.3288 7.852 14.4H15.2C15.6424 14.4 16 14.0424 16 13.6C16 13.1576 15.6424 12.8 15.2 12.8ZM15.2 7.2H12.652C12.3208 6.2712 11.4416 5.6 10.4 5.6C9.3584 5.6 8.4792 6.2712 8.148 7.2H0.8C0.3576 7.2 0 7.5576 0 8C0 8.4424 0.3576 8.8 0.8 8.8H8.148C8.4792 9.7288 9.3584 10.4 10.4 10.4C11.4416 10.4 12.3208 9.7288 12.652 8.8H15.2C15.6424 8.8 16 8.4424 16 8C16 7.5576 15.6424 7.2 15.2 7.2ZM5.6 1.6C6.0416 1.6 6.4 1.9584 6.4 2.4C6.4 2.8416 6.0416 3.2 5.6 3.2C5.1584 3.2 4.8 2.8416 4.8 2.4C4.8 1.9584 5.1584 1.6 5.6 1.6ZM5.6 14.4C5.1584 14.4 4.8 14.0416 4.8 13.6C4.8 13.1584 5.1584 12.8 5.6 12.8C6.0416 12.8 6.4 13.1584 6.4 13.6C6.4 14.0416 6.0416 14.4 5.6 14.4ZM10.4 8.8C9.9584 8.8 9.6 8.4416 9.6 8C9.6 7.5584 9.9584 7.2 10.4 7.2C10.8416 7.2 11.2 7.5584 11.2 8C11.2 8.4416 10.8416 8.8 10.4 8.8Z"
//     fill="#222222"
//   />
// </svg>
//                   </span>
//                 </div>           
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="flex justify-between items-center px-6 p-4 border-b-[1px] product-view-container w-full">
//             <div className="font-primaryFont all-products-length">
//                 <span className="font-[580] text-sm tracking-wider">{filterProducts.length} Products</span>
//             </div>
//             <div className="flex justify-between items-center product-view-filter cursor-pointer">
//             <div
//         className={`flex p-2 border one-product `}
//         onClick={() => setGridLayout('one-product')}
//       >
//                     <div className={` w-[20px] h-[20px] box ${gridLayout === 'one-product' ? 'bg-black' : 'bg-gray-300'}`}></div>
//                 </div>
//                 <div
//         className={`flex justify-between items-center gap-1 p-2 border two-product `}
//         onClick={() => setGridLayout('two-product')}
//       >                <div className={` w-[5px] h-[20px] box ${gridLayout === 'two-product' ? 'bg-black' : 'bg-gray-300'}`}></div>
//                 <div className={` w-[5px] h-[20px] box ${gridLayout === 'two-product' ? 'bg-black' : 'bg-gray-300'}`}></div>
//                 </div>
//                 <div
//         className={`flex justify-between items-center gap-1 p-2 border four-product `}
//         onClick={() => setGridLayout('four-product')}
//       >         <div className={` w-[5px] h-[20px] box ${gridLayout === 'four-product' ? 'bg-black' : 'bg-gray-300'}`}></div>
//                 <div className={` w-[5px] h-[20px] box ${gridLayout === 'four-product' ? 'bg-black' : 'bg-gray-300'}`}></div>
//                 <div className={` w-[5px] h-[20px] box ${gridLayout === 'four-product' ? 'bg-black' : 'bg-gray-300'}`}></div>
//                 <div className={` w-[5px] h-[20px] box ${gridLayout === 'four-product' ? 'bg-black' : 'bg-gray-300'}`}></div>
//                 </div>
//             </div>
//         </div>
//         <section id="all-prodcuts" className="mt-2">
//         <div className={`justify-center gap-4 grid p-2 ${gridClass}`}>
//         {filterProducts.slice(0, visibleProducts).map((product, index) => {
//             return <ProductCard key={product.id} product={product} productCss="w-full p-2"/>
//         })}
        
//       </div>
//       <div className="flex justify-center items-center my-4 px-6 show-more-btn show-more-btn w-full">
       
//         <button className="hover:shadow-lg px-4 p-3 border hover:font-bold text-[12px] text-primary capitalize" onClick={handleShowMore} style={{letterSpacing:'1px'}}>Show More</button>
  
//         </div>
//     </section>
//       </div>
//       <Footer />
//     </div>
//   );
// }

// export default Products;*/
